import { render, staticRenderFns } from "./CustomPaymentDetailsCollapse.vue?vue&type=template&id=0cad7af0&scoped=true&"
import script from "./CustomPaymentDetailsCollapse.vue?vue&type=script&lang=js&"
export * from "./CustomPaymentDetailsCollapse.vue?vue&type=script&lang=js&"
import style0 from "./CustomPaymentDetailsCollapse.vue?vue&type=style&index=0&id=0cad7af0&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cad7af0",
  null
  
)

export default component.exports